<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/search.json"></i18n>
<i18n src="@/lang/table.json"></i18n>

<template>
  <el-container>
    <template v-if="!Array.isArray(tableData)">
      <el-table :data="Object.keys(tableData)">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <services-table
              :data="tableData[scope.row]"
              :group-level="groupLevel + 1"
              @handleAction="handleAction"
            />
          </template>
        </el-table-column>
        <el-table-column :sortable="false">
          <template slot="header">
            <span
              v-text="
                'group_by   :' + $t(schema[apply_group_by[groupLevel]].label)
              "
            />
          </template>
          <template slot-scope="scope">
            <span v-text="scope.row" />
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-else>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <template v-for="(v, key) in scope.row.details">
              <div :key="key" v-if="v">
                <i v-bind="v.status.icon" />
                <span
                  v-text="$t('service.details.' + key)"
                  class="details-label"
                />
                <extra-element
                  :value="v.value"
                  :extra-data="v.extra"
                  class="details-value"
                />
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column width="25px">
          <template slot-scope="scope">
            <i
              class="el-icon-error"
              style="color:red"
              v-if="scope.row.canDelete"
            />
            <i
              v-else
              :class="{
                'el-icon-check': scope.row.checkStatus === 'ok',
                'el-icon-close': scope.row.checkStatus === 'error'
              }"
              :style="[
                { color: scope.row.checkStatus === 'ok' ? 'green' : 'red' },
                { fontWeight: 'bold' }
              ]"
            />
          </template>
        </el-table-column>
        <el-table-column width="100px">
          <el-image slot-scope="scope" :src="scope.row.image" fit="cover" />
        </el-table-column>
        <template v-for="(v, key) in schema">
          <el-table-column
            :key="key"
            v-if="!apply_group_by.includes(key)"
            sortable
            :label="$t(v.label)"
            :prop="key"
          >
            <template slot-scope="scope">
              <!--                            <i class="el-icon-error" style="color:red" v-if="scope.row.canDelete"/>-->
              <span style="margin-left: 10px">{{ scope.row[key] }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column :label="$t('table.operations')" align="right">
          <template slot-scope="scope">
            <el-dropdown
              split-button
              size="small"
              type="info"
              trigger="click"
              @click="handleShowDetails(scope.$index, scope.row)"
              @command="
                (...args) => {
                  handleAction(args[0], scope.$index, scope.row);
                }
              "
            >
              {{ $t("actions.show_details") }}
              <el-dropdown-menu>
                <el-dropdown-item command="open_for_edit"
                  >{{ $t("actions.edit") }}
                </el-dropdown-item>
                <el-dropdown-item command="delete"
                  >{{ $t("actions.delete") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ExtraElement from "./extraElement";

export default {
  name: "ServicesTable",
  components: { ExtraElement },
  props: {
    data: {
      default: () => []
    },
    groupLevel: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      schema: {
        customerName: { label: "table.customer", hasChildren: true },
        amoDomain: { label: "table.amocrm", hasChildren: true },
        apiKey: { label: "table.apiKey", hasChildren: true },
        serviceCode: { label: "table.service", hasChildren: true }
      }
    };
  },
  methods: {
    handleAction(name, params, model) {
      this.$log("handleAction", { ...arguments });
      this.$emit("handleAction", name, params, model);
    },
    handleShowDetails(index, row) {
      this.$log("handleShowDetails", { ...arguments });
      this.$emit("handleShowDetails", index, row);
    },
    emitStatus(v) {
      this.$log("emitStatus", v);
    }
  },
  computed: {
    tableData() {
      return this.data;
    },
    ...mapGetters({
      group_by: "shared_customers_services_list/group_by"
    }),
    ...mapState("shared_customers_services_list", ["apply_group_by"])
  }
};
</script>

<style scoped lang="stylus">
.details-label
  font-weight bold
.details-value
  margin-left 10px
</style>
